import { LoadPanel } from 'devextreme-react';
import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { updPwdReq } from '../../api/forgotPwdApi';
import CustomButton from '../customButton/CustomButton';
import CustomGoBack from '../customGoBack/CustomGoBack';
import { ToastDisplayer } from '../toastDisplay/ToastDisplayer';

export default function RequestPwdForm({emailOtp,otpRole,onReqPwdFormGoBack}) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendReq=async ()=>{
    try {
      setLoading(true);
      const result=await updPwdReq(emailOtp,otpRole)

      if (result?.status === 200 && result?.data) {
        ToastDisplayer("success", result.data.message);
        navigate("/feedbackPasswordPage",{state:{  requestPwd:"yes" }});
      }
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || "An unexpected error occurred.");
    }finally{
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onReqPwdFormGoBack} />

      <div className="resetHeader">Reset Password</div>
      <div className="resetText">Type your email address to get an OTP</div>

      <div className="mySpace">
        <CustomButton text="Send Request" onClick={handleSendReq} />
      </div>

    </>
  )
}
